import { createSelector } from "reselect"
import { get } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeResourcePermissionsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"
import { getFullResourceType } from "modules/resources/helpers"

const EMPTY_ARRAY = []

export const getResourceType = (_, props) => getFullResourceType(props.params.resourceType)
export const getResourceId = (_, props) => get(props, "resourceApplications.resource.id")
export const getResourceApplications = (_, props) => get(props, "resourceApplications.resource.applications", EMPTY_ARRAY)
export const getAccountApplications = (_, props) => get(props, "accountApplications.applications", EMPTY_ARRAY)
export const getPermissionLevel = (_, props) => get(props, "resourceApplications.resource.permissionLevel")

export const getTabs = createSelector(
  [getRoute, getPath, getResourceType, getIsOpPro],
  computeResourcePermissionsTabs,
)
